import { Notifier } from "@airbrake/browser";

if (window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.nl",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();
window.abortController = undefined;

import AuthorizeInteractionController from "./controllers/authorize_interaction_controller";
import BodyScrollController from "./controllers/body_scroll_controller";
import ButtonCopyController from "./controllers/button_copy_controller";
import CartConfirmationController from "./controllers/cart_confirmation_controller";
import CartContactController from "./controllers/cart_contact_controller";
import CartController from "./controllers/cart_controller";
import CartCounterController from "./controllers/cart_counter_controller";
import CartPaymentMethodsController from "./controllers/cart_payment_methods_controller";
import CartPaypalConfirmationController from "./controllers/cart_paypal_confirmation_controller";
import CartShippingController from "./controllers/cart_shipping_controller";
import ContactController from "./controllers/contact_controller";
import CountryController from "./controllers/country_controller";
import DeviceDetectorController from "./controllers/device_detector_controller";
import FloatingAlertController from "./controllers/floating_alert_controller";
import LabelController from "./controllers/label_controller";
import ModalController from "./controllers/modal_controller";
import NotificationController from "./controllers/notification_controller";
import OrderController from "./controllers/order_controller";
import PostalCodeController from "./controllers/postal_code_controller";
import ShareController from "./controllers/share_controller";
import StateController from "./controllers/state_controller";
import StockController from "./controllers/stock_controller";
import TabsController from "./controllers/tabs_controller";

import { makeClient } from '@spree/storefront-api-v2-sdk';
import { Sutty } from './endpoints/sutty';

window.spree = makeClient({ host: window.env.SPREE_URL });
window.spree.sutty = new Sutty(window.spree.host);

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("authorize-interaction", AuthorizeInteractionController);
Stimulus.register("body-scroll", BodyScrollController);
Stimulus.register("button-copy", ButtonCopyController);
Stimulus.register("cart-confirmation", CartConfirmationController);
Stimulus.register("cart-contact", CartContactController);
Stimulus.register("cart", CartController);
Stimulus.register("cart-counter", CartCounterController);
Stimulus.register("cart-payment-methods", CartPaymentMethodsController);
Stimulus.register("cart-paypal-confirmation", CartPaypalConfirmationController);
Stimulus.register("cart-shipping", CartShippingController);
Stimulus.register("contact", ContactController);
Stimulus.register("country", CountryController);
Stimulus.register("device-detector", DeviceDetectorController);
Stimulus.register("floating-alert", FloatingAlertController);
Stimulus.register("label", LabelController);
Stimulus.register("modal", ModalController);
Stimulus.register("notification", NotificationController);
Stimulus.register("order", OrderController);
Stimulus.register("postal-code", PostalCodeController);
Stimulus.register("share", ShareController);
Stimulus.register("state", StateController);
Stimulus.register("stock", StockController);
Stimulus.register("tabs", TabsController);

document.addEventListener("turbo:load", (event) => {
  document
    .querySelectorAll("a[href^='http://'],a[href^='https://'],a[href^='//']")
    .forEach((a) => {
      a.rel = "noopener";
      a.target = "_blank";
    });

  window.abortController = new AbortController();
});

document.addEventListener("turbo:visit", (event) => {
  window.abortController.abort();
});
